"use client";
import { getPrimaryShade } from "../get-primary-shade/get-primary-shade.mjs";
import { parseThemeColor } from "../parse-theme-color/parse-theme-color.mjs";
import { isVirtualColor } from "../../MantineCssVariables/virtual-color/virtual-color.mjs";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/get-contrast-color/get-contrast-color.ts
function getContrastColor({ color, theme, autoContrast, colorScheme }) {
	if (!(typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast)) return "var(--mantine-color-white)";
	return parseThemeColor({
		color: color || theme.primaryColor,
		theme,
		colorScheme
	}).isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
}
function getVirtualColorContrast(value, theme, colorScheme) {
	return getContrastColor({
		color: colorScheme === "dark" ? value.dark : value.light,
		theme,
		colorScheme,
		autoContrast: true
	});
}
function getPrimaryContrastColor(theme, colorScheme) {
	const primaryColor = theme.colors[theme.primaryColor];
	if (isVirtualColor(primaryColor)) {
		if (!theme.autoContrast) return "var(--mantine-color-white)";
		return getVirtualColorContrast(primaryColor, theme, colorScheme);
	}
	return getContrastColor({
		color: primaryColor[getPrimaryShade(theme, colorScheme)],
		theme,
		autoContrast: null
	});
}
//#endregion
export { getContrastColor, getPrimaryContrastColor, getVirtualColorContrast };

//# sourceMappingURL=get-contrast-color.mjs.map